import { useEffect, useState } from 'react'

import { Box, Card, Container, Flex, Text } from '@chakra-ui/react'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { useTranslation } from 'react-i18next'

import { useGetThemeQuery } from '@core/app/api/globalApi'
import { forgotCurrentStep } from '@core/app/slices/auth'
import bg from '@core/assets/images/register_bg.jpg'
import { Header } from '@core/components/Header/Header'
import { RECAPTCHA } from '@core/utils/constants/constants'
import { useAppTheme } from '@core/utils/contexts/ThemeContext/ThemeContext'
import { useAppSelector } from '@core/utils/hooks/hook'
import i18n from '@core/utils/i18n'

import { EmailValidation } from '@page/forgot-password/components/emailValidation/emailValidation'
import { ForgotPassword } from '@page/forgot-password/components/forgotPassword/forgotPassword'
import { NewPassword } from '@page/forgot-password/components/newPassword/newPassword'
import { Reseted } from '@page/forgot-password/components/reseted/reseted'

export const ForgotPage = () => {
    const step = useAppSelector(forgotCurrentStep)
    const { t } = useTranslation()
    const { appTheme, isExpired, updateTheme } = useAppTheme()
    const { data: theme } = useGetThemeQuery({}, { skip: isExpired })

    const [bgImage, setBgImage] = useState<string>('')

    useEffect(() => {
        if (!appTheme) return
        const newSettings = appTheme?.newSettings?.general
        if (newSettings) {
            if (newSettings.BackgroundUrl) {
                setBgImage(newSettings.BackgroundUrl)
            } else {
                setBgImage(bg)
            }
        } else {
            setBgImage(bg)
        }
    }, [appTheme])

    useEffect(() => {
        if (theme) {
            updateTheme(theme)
        }
    }, [theme])

    return (
        <Flex
            minH={'100vh'}
            // bgImage={bgImage && bgImage}
            bgImage={appTheme?.newSettings?.general?.BackgroundUrl ?? bg}
            backgroundSize={'cover'}
            flexDirection={'column'}
        >
            <Header />
            {/*<GoogleReCaptchaProvider*/}
            {/*    reCaptchaKey={RECAPTCHA}*/}
            {/*    useEnterprise={true}*/}
            {/*    language={i18n.language}*/}
            {/*>*/}
            <Box as={'section'} flexGrow={1} display={'flex'} alignItems={'center'}>
                <Container maxW={{ base: 'container.sm', xl: 'container.xl' }} h={'full'}>
                    <Flex justifyContent={'end'} alignItems={'center'} h={'full'}>
                        <Card
                            w={{ base: '100%', xl: '432px' }}
                            bg={'text.white'}
                            py={{ base: '28px', xl: '44px' }}
                            px={{ base: '32px', xl: '48px' }}
                            my={{ base: 0, xl: '32px' }}
                            mx={{ base: 0, xl: '32px' }}
                        >
                            {step === 'forgotPassword' ? <ForgotPassword /> : null}
                            {step === 'emailValidation' ? <EmailValidation /> : null}
                            {step === 'newPassword' ? <NewPassword /> : null}
                            {step === 'passwordReset' ? <Reseted /> : null}
                        </Card>
                    </Flex>
                </Container>
            </Box>
            {/*</GoogleReCaptchaProvider>*/}
            <Box as={'footer'} py={{ base: 8, xl: 10 }}>
                <Container maxW={{ base: 'container.sm', xl: 'container.xl' }}>
                    <Flex justifyContent={{ base: 'center', xl: 'end' }}>
                        <Text color={'text.white'} fontSize={'xs'}>
                            {t('6587')} -{' '}
                            <Box as={'a'} href={'/privacy-policy'} color={'text.link'} target={'_blank'}>
                                {t('5034')}
                            </Box>
                        </Text>
                    </Flex>
                </Container>
            </Box>
        </Flex>
    )
}
